var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function area"
  }, [_c("section", {
    staticClass: "product-function__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("FUNCTION")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("功能介绍")])]), _c("section", {
    staticClass: "product-function__introduction"
  }, [_c("section", {
    staticClass: "part left clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_1.png"),
      alt: ""
    }
  }), _c("section", {
    staticClass: "contents"
  }, [_c("section", {
    staticClass: "title puhui-M"
  }, [_vm._v("篮子交易，多股票同步追踪")]), _c("section", {
    staticClass: "info"
  }, [_vm._v(" 支持本地文件扫单导入、问财选股、公式选股等方式构建用户专属投资股票池，可同步同花顺行情端个人自选股；配合多种交易方式快捷完成多股票同时交易。 ")])])]), _c("section", {
    staticClass: "part right clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_2.png"),
      alt: ""
    }
  }), _c("section", {
    staticClass: "contents"
  }, [_c("section", {
    staticClass: "title puhui-M"
  }, [_vm._v("篮子交易，多股票同步追踪")]), _c("section", {
    staticClass: "info"
  }, [_vm._v(" 支持本地文件扫单导入、问财选股、公式选股等方式构建用户专属投资股票池，可同步同花顺行情端个人自选股；配合多种交易方式快捷完成多股票同时交易。 ")])])])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };